import { DropdownButton, MenuItem } from 'react-bootstrap';
import '../styles/flags.css';

const ExportPdfButton = ({ onExport, fromPdf }) => {
  const handleExportPdfByPodcast = (e) => {
    e.preventDefault();
    onExport('pdf', 'podcast');
  };

  const handleExportPdfByTag = (e) => {
    e.preventDefault();
    onExport('pdf', 'tag');
  };

  const titleButton = (
    <div className="btn-tags__title">
      <span>Export PDF</span>
      <i className="fa fa-download" aria-hidden="true"></i>
    </div>
  );

  return (
    <DropdownButton
      id="flags-export-menu"
      title={titleButton}
      className={`flags-actions__btn-tags flags-actions-btn${
        fromPdf ? ' flags-actions__btn-tags--from-pdf' : ''
      }`}
      onClick={(e) => {
        e.preventDefault();
        return false;
      }}
    >
      <MenuItem
        pdown="true"
        eventKey="1"
        onClick={(e) => handleExportPdfByPodcast(e)}
      >
        <i className="fa">&#xf1c1;</i> Sort by Podcast
      </MenuItem>
      <MenuItem pdown="true" eventKey="2" onClick={(e) => handleExportPdfByTag(e)}>
        <i className="fa">&#xf1c1;</i> Sort by Tag
      </MenuItem>
    </DropdownButton>
  );
};

export default ExportPdfButton;
